import angular from 'angular';

module.exports = angular.module('common.controllers', [
  require('./style-list'),
  require('./style-mocks'),
  require('./style-single'),
])
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/controllers/index.js
 **/